<script>
    import { createEventDispatcher } from 'svelte';

    import State from 'src/fields/State/State.svelte';

    export let date;
    export let hours;
    export let landings;
    export let cycles;

    export let dateInitial;
    export let hoursInitial;
    export let landingsInitial;
    export let cyclesInitial;

    function fillByInitials() {
        date = dateInitial;
        hours = hoursInitial;
        landings = landingsInitial;
        cycles = cyclesInitial;
    }

    const dispatch = createEventDispatcher();
</script>

<div>
    <div style="margin-bottom: 10px">
        <a
            class="link"
            style="cursor: pointer;"
            on:click={fillByInitials}
        >
            Use current times
        </a>
    </div>

    <State
        {...$$restProps}

        bind:date
        bind:hours
        bind:landings
        bind:cycles

        on:change={({ detail: value }) => dispatch('change', value)}
    />
</div>
